<template>
    <div>
        <router-link :to="{name: 'locator.firmsAndCraftsmen'}">firmy a řemeslnícic</router-link>
        <router-link :to="{name: 'locator.salesPlaces'}">prodejni mista</router-link>
    </div>
</template>

<script>
    export default {
        name: 'LocatorSelect',
    }
</script>



// WEBPACK FOOTER //
// src/components/locator/LocatorSelect.vue